<template>
    <div class="info-card">
        <template v-if="incomeType === 1">
            <div class="title"><div>9A 執行業務所得</div></div>
            <div>
                <table class="info-table" cellpadding="0" cellspacing="0">
                    <tr>
                        <th style="min-width: 140px"></th>
                        <th style="width: 50%;">本國人、外國人在台居住滿 183 天</th>
                        <th style="width: 50%;">外國人在台居住未滿 183 天</th>
                    </tr>
                    <tr>
                        <td class="row-th">代扣繳所得稅</td>
                        <td>給付金額達 20,010 元（應扣繳稅額超過 {{ TAX_AMT_THRESHOLD.toLocaleString() }} 元）應扣繳 10%（無條件捨去）</td>
                        <td>給付金額達 {{ NOT_RESIDENT_AMT_TAX_THRESHOLD.toLocaleString() }} 元，應扣繳 20%（無條件捨去）</td>
                    </tr>
                    <tr>
                        <td class="row-th">代扣繳二代健保費</td>
                        <td>給付金額達 {{ GEN2_THRESHOLD.toLocaleString() }} 元，應扣繳 2.11%（四捨五入）<br />有投保職業工會者免扣。</td>
                        <td>給付金額達 {{ GEN2_THRESHOLD.toLocaleString() }} 元，應扣繳 2.11%（四捨五入）<br />無投保健保者免扣。</td>
                    </tr>
                </table>
                <div style="display: flex; justify-content: end; gap: 6px;">
                    <a href="https://www.etax.nat.gov.tw/etwmain/tax-info/understanding/tax-q-and-a/national/individual-income-tax/withheld-rule/rule/a7BB6R9" target="_blank">參考1</a>
                    <a href="https://www.etax.nat.gov.tw/etwmain/tax-info/innotative-tax-e-reference/withheld/regulation/Prj8q2V" target="_blank">參考2</a>
                    <a href="https://www.nhi.gov.tw/ch/cp-4516-74b0f-2613-1.html" target="_blank">參考3</a>
                </div>
            </div>
        </template>
        <template v-if="incomeType === 2">
            <div class="title"><div>9B 稿費</div></div>
            <div>
                <table class="info-table" cellpadding="0" cellspacing="0">
                    <tr>
                        <th style="min-width: 140px"></th>
                        <th style="width: 50%;">本國人、外國人在台居住滿 183 天</th>
                        <th style="width: 50%;">外國人在台居住未滿 183 天</th>
                    </tr>
                    <tr>
                        <td class="row-th">代扣繳所得稅</td>
                        <td>給付金額達 20,010 元（應扣繳稅額超過 {{ TAX_AMT_THRESHOLD.toLocaleString() }} 元）應扣繳 10%（無條件捨去）</td>
                        <td>給付金額達 {{ NOT_RESIDENT_AMT_TAX_THRESHOLD.toLocaleString() }} 元，應扣繳 20%（無條件捨去）</td>
                    </tr>
                    <tr>
                        <td class="row-th">代扣繳二代健保費</td>
                        <td>給付金額達 {{ GEN2_THRESHOLD.toLocaleString() }} 元，應扣繳 2.11%（四捨五入）<br />有投保職業工會者免扣。</td>
                        <td>給付金額達 {{ GEN2_THRESHOLD.toLocaleString() }} 元，應扣繳 2.11%（四捨五入）<br />無投保健保者免扣。</td>
                    </tr>
                </table>
                <div style="display: flex; justify-content: end; gap: 6px;">
                    <a href="https://www.etax.nat.gov.tw/etwmain/tax-info/understanding/tax-q-and-a/national/individual-income-tax/withheld-rule/rule/a7BB6R9" target="_blank">參考1</a>
                    <a href="https://www.etax.nat.gov.tw/etwmain/tax-info/innotative-tax-e-reference/withheld/regulation/Prj8q2V" target="_blank">參考2</a>
                    <a href="https://www.nhi.gov.tw/ch/cp-4516-74b0f-2613-1.html" target="_blank">參考3</a>
                </div>
            </div>
        </template>
        <template v-if="incomeType === 4">
            <div class="title"><div>51 租金收入</div></div>
            <div>
                <table class="info-table" cellpadding="0" cellspacing="0">
                    <tr>
                        <th style="min-width: 140px"></th>
                        <th style="width: 50%;">本國人、外國人在台居住滿 183 天</th>
                        <th style="width: 50%;">外國人在台居住未滿 183 天</th>
                    </tr>
                    <tr>
                        <td class="row-th">代扣繳所得稅</td>
                        <td>給付金額達 20,010 元（應扣繳稅額超過 {{ TAX_AMT_THRESHOLD.toLocaleString() }} 元）應扣繳 10%（無條件捨去）</td>
                        <td>給付金額達 {{ NOT_RESIDENT_AMT_TAX_THRESHOLD.toLocaleString() }} 元，應扣繳 20%（無條件捨去）</td>
                    </tr>
                    <tr>
                        <td class="row-th">代扣繳二代健保費</td>
                        <td>給付金額達 {{ GEN2_THRESHOLD.toLocaleString() }} 元，應扣繳 2.11%（四捨五入）<br />有投保職業工會者免扣。</td>
                        <td>給付金額達 {{ GEN2_THRESHOLD.toLocaleString() }} 元，應扣繳 2.11%（四捨五入）<br />無投保健保者免扣。</td>
                    </tr>
                </table>
                <div style="display: flex; justify-content: end; gap: 6px;">
                    <a href="https://www.etax.nat.gov.tw/etwmain/tax-info/understanding/tax-q-and-a/national/individual-income-tax/withheld-rule/rule/a7BB6R9" target="_blank">參考1</a>
                    <a href="https://www.etax.nat.gov.tw/etwmain/tax-info/innotative-tax-e-reference/withheld/regulation/Prj8q2V" target="_blank">參考2</a>
                    <a href="https://www.nhi.gov.tw/ch/cp-4516-74b0f-2613-1.html" target="_blank">參考3</a>
                </div>
            </div>
        </template>
        <template v-if="incomeType === 5">
            <div class="title">91 競技、競賽及機會中獎之獎金</div>
            <div>
                <table class="info-table" cellpadding="0" cellspacing="0">
                    <tr>
                        <th style="min-width: 140px"></th>
                        <th style="width: 50%;">本國人、外國人在台居住滿 183 天</th>
                        <th style="width: 50%;">外國人在台居住未滿 183 天</th>
                    </tr>
                    <tr>
                        <td class="row-th">代扣繳所得稅</td>
                        <td>給付金額達 20,010 元（應扣繳稅額超過 {{ TAX_AMT_THRESHOLD.toLocaleString() }} 元）應扣繳 10%（無條件捨去）</td>
                        <td>給付金額達 {{ NOT_RESIDENT_AMT_TAX_THRESHOLD.toLocaleString() }} 元，應扣繳 20%（無條件捨去）</td>
                    </tr>
                    <tr>
                        <td class="row-th">代扣繳二代健保費</td>
                        <td>免扣。</td>
                        <td>免扣。</td>
                    </tr>
                </table>
                <div style="display: flex; justify-content: end; gap: 6px;">
                    <a href="https://www.etax.nat.gov.tw/etwmain/tax-info/understanding/tax-q-and-a/national/individual-income-tax/withheld-rule/rule/a7BB6R9" target="_blank">參考1</a>
                    <a href="https://www.etax.nat.gov.tw/etwmain/tax-info/innotative-tax-e-reference/withheld/regulation/Prj8q2V" target="_blank">參考2</a>
                    <a href="https://www.nhi.gov.tw/ch/cp-4516-74b0f-2613-1.html" target="_blank">參考3</a>
                </div>
            </div>
        </template>
        <template v-if="incomeType === 3">
            <div class="title">50 薪資所得</div>
            <div>
                <table class="info-table" cellpadding="0" cellspacing="0">
                    <tr>
                        <th style="min-width: 140px"></th>
                        <th style="width: 50%;">本國人、外國人在台居住滿 183 天</th>
                        <th style="width: 50%;">外國人在台居住未滿 183 天</th>
                    </tr>
                    <tr>
                        <td class="row-th">代扣繳所得稅</td>
                        <td>按薪資所得扣繳稅額表 (115年起扣金額 {{ SALARY_TAX_THRESHOLD.toLocaleString() }})，應扣繳 5%（無條件捨去）</td>
                        <td>應扣繳 18%（無條件捨去），全月薪資給付總額在行政院核定每月基本工資 1.5 倍以下者 6%（每月最低工資自114年1月1日起為 {{ MINIMUM_WAGE.toLocaleString() }}）</td>
                    </tr>
                    <tr>
                        <td class="row-th">代扣繳二代健保費</td>
                        <td>給付金額達基本工資 {{ MINIMUM_WAGE.toLocaleString() }} 元，應扣繳 2.11%（四捨五入）<br />有投保職業工會者免扣。</td>
                        <td>給付金額達基本工資 {{ MINIMUM_WAGE.toLocaleString() }} 元，應扣繳 2.11%（四捨五入）<br />無投保健保者免扣。</td>
                    </tr>
                </table>
                <div style="display: flex; justify-content: end; gap: 6px;">
                    <a href="https://www.etax.nat.gov.tw/etwmain/tax-info/innotative-tax-e-reference/withheld/regulation/Prj8q2V" target="_blank">參考1</a>
                    <a href="https://www.nhi.gov.tw/ch/cp-4516-74b0f-2613-1.html" target="_blank">參考2</a>
                </div>
            </div>
        </template>
        <template v-if="incomeType === 6">
            <div class="title">53 權利金</div>
            <div>
                <table class="info-table" cellpadding="0" cellspacing="0">
                    <tr>
                        <th style="min-width: 140px"></th>
                        <th style="width: 50%;">本國人、外國人在台居住滿 183 天</th>
                        <th style="width: 50%;">外國人在台居住未滿 183 天</th>
                    </tr>
                    <tr>
                        <td class="row-th">代扣繳所得稅</td>
                        <td>給付金額達 20,010 元（應扣繳稅額超過 {{ TAX_AMT_THRESHOLD.toLocaleString() }} 元）應扣繳 10%（無條件捨去）</td>
                        <td>無論金額多寡，應扣繳 20%（無條件捨去）</td>
                    </tr>
                    <tr>
                        <td class="row-th">代扣繳二代健保費</td>
                        <td>免扣。</td>
                        <td>免扣。</td>
                    </tr>
                </table>
                <div style="display: flex; justify-content: end; gap: 6px;">
                    <a href="https://www.etax.nat.gov.tw/etwmain/tax-info/understanding/tax-q-and-a/national/individual-income-tax/withheld-rule/rule/a7BB6R9" target="_blank">參考1</a>
                    <a href="https://www.etax.nat.gov.tw/etwmain/tax-info/innotative-tax-e-reference/withheld/regulation/Prj8q2V" target="_blank">參考2</a>
                    <a href="https://www.nhi.gov.tw/ch/cp-4516-74b0f-2613-1.html" target="_blank">參考3</a>
                </div>
            </div>
        </template>
        <template v-if="incomeType === 0">
            <div class="title">92 其他</div>
            <div>
                <table class="info-table" cellpadding="0" cellspacing="0">
                    <tr>
                        <th style="min-width: 140px"></th>
                        <th style="width: 50%;">本國人、外國人在台居住滿 183 天</th>
                        <th style="width: 50%;">外國人在台居住未滿 183 天</th>
                    </tr>
                    <tr>
                        <td class="row-th">代扣繳所得稅</td>
                        <td>無</td>
                        <td>無</td>
                    </tr>
                    <tr>
                        <td class="row-th">代扣繳二代健保費</td>
                        <td>無</td>
                        <td>無</td>
                    </tr>
                </table>
                <div style="display: flex; justify-content: end; gap: 6px;">
                    <a href="https://www.etax.nat.gov.tw/etwmain/tax-info/innotative-tax-e-reference/withheld/regulation/Prj8q2V" target="_blank">參考1</a>
                    <a href="https://www.nhi.gov.tw/ch/cp-4516-74b0f-2613-1.html" target="_blank">參考2</a>
                </div>
            </div>
        </template>
        <slot />
    </div>
</template>
<script>
import {
    TAX_AMT_THRESHOLD,
    NOT_RESIDENT_AMT_TAX_THRESHOLD,
    SALARY_TAX_THRESHOLD,
    MINIMUM_WAGE,
    GEN2_THRESHOLD,
} from '@/utils/OutsourcingPersonalTaxHelpers';

export default {
    name: 'ah-outsourcing-personal-tax-info',
    props: {
        // 所得類別
        // 1:9A 執行業務所得
        // 2:9B 稿費
        // 3:50 薪資所得
        // 4:51 租金收入
        // 5:91 競技、競賽及機會中獎之獎金
        incomeType: {
            type: Number,
            default: 1,
        },
    },
    data() {
        return {
            TAX_AMT_THRESHOLD,
            NOT_RESIDENT_AMT_TAX_THRESHOLD,
            SALARY_TAX_THRESHOLD,
            MINIMUM_WAGE,
            GEN2_THRESHOLD,
        };
    },
};
</script>
<style lang="scss">
.info-card {
    background-color: #fdf6ec;
    font-size: 10pt;
    padding: 25px 35px;
    line-height: 150%;
    border-radius: 10px;

    .title {
        font-size: 11pt;
        font-weight: bold;
        margin-bottom: 20px;
    }

    .section {
        margin: 15px 0;
    }
    .sub-section {
        padding-left: 20px;
    }
    .info-table {
        // border-top: 1px solid #ccc;
        td, th {
            font-size: 10pt;
            padding: 7px 15px;
            border-bottom: 1px solid #ccc;

            &.row-th {
                background-color: #f9ecda;
            }
        }
        margin-bottom: 15px;
    }
}
</style>
